
/// <amd-module name="Wit/Common/WorkItemControls/Constants" />

export const FutureDate = new Date(253370764800000);
